import React from 'react'
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import timesheet from '../../pages/Features/Timesheet/Timesheet.module.css';
import { useTimesheetChart } from '../../Hooks/Features/Timesheet/useTimesheetChart';
import { SkeletonContainer } from '../Loader/Loader';

function TimesheetChart({ filterValues, setFilterValues, tab }) {

  const { dataSetFlag, allCharts, chartOptions } = useTimesheetChart({ filterValues, setFilterValues, tab });

  return (
    <div className={timesheet["chart-main-container"]}>
      <div className={timesheet["chart-container"]}>
        {!dataSetFlag ? <>
          {allCharts?.length > 0 ? allCharts.map((chart, index) => (
            <div key={index} className="chart-each">
              <h5 className={timesheet["chart-title"]}>{chart.chart_name}</h5>
              <div style={{ height: "86%" }}>
                <HighchartsReact highcharts={Highcharts} options={chartOptions[chart.chart_name]} containerProps={{ style: { height: "100%" } }} />
              </div>
            </div>
          )) :
            <div className='text-center'>
              <img src={"./assets/nodata.jpg"} alt='no data' />
              <p className='text-center red mt-3'> Data Not Found</p>
            </div>
          }
        </>
          :
          <div style={{ display: "flex", justifyContent: "space-evenly", rowGap: "20px", flexWrap: "wrap" }}>
            {Array.from({ length: 6 }, (_, index) => (
              <div style={{ width: "26vw", height: "43vh" }}><SkeletonContainer /></div>
            ))}
          </div>
        }
      </div>
    </div>
  )
}

export default TimesheetChart